/**
 * GET /api/v1/agent/activity - the running feed behind the Activity
 * page (Greg, 2026-07-30).
 *
 * Polls on the same 30s cadence as the sidebar badges. It is a feed:
 * an agent leaves it open and expects it to move on its own, and the
 * backend query is bounded (see ``_ACTIVITY_CANDIDATE_POOL``) so the
 * poll stays cheap regardless of ticket count.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import api from "@/lib/api";
import type { ActivityRow } from "@/types/api";

export const ACTIVITY_FEED_QUERY_KEY = ["agent", "activity"] as const;

export function useActivityFeed(
  limit = 50,
): UseQueryResult<ActivityRow[]> {
  return useQuery({
    queryKey: [...ACTIVITY_FEED_QUERY_KEY, limit],
    queryFn: async () => {
      const response = await api.get<ActivityRow[]>("/agent/activity", {
        params: { limit },
      });
      return response.data;
    },
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}
